import React from "react"
import FieldProto_FormElement from "../../../../proto/render/form-element";
import FieldCheckbox_FormCommon from "./form/form-view";

export default class FieldCheckbox_FormElement extends FieldProto_FormElement {

    render() {
        return <FieldCheckbox_FormCommon field={this.props.field}
                                         value={this.value}
                                         onChange={this.onChange}
                                         disabled={this.props.disabled}
                                         className={this.props.className} />
    }

}